/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2024, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

import mount from 'utils/mount';

import LadTableSet from './components/LadTableSet.vue';
import LADTableConfiguration from './LADTableConfiguration.js';

export default class LadTableSetView {
  constructor(openmct, domainObject, objectPath) {
    this.openmct = openmct;
    this.domainObject = domainObject;
    this.objectPath = objectPath;
    this._destroy = null;
    this.component = null;
  }

  show(element, isEditing, { renderWhenVisible }) {
    let ladTableConfiguration = new LADTableConfiguration(this.domainObject, this.openmct);

    const { vNode, destroy } = mount(
      {
        el: element,
        components: {
          LadTableSet
        },
        provide: {
          openmct: this.openmct,
          objectPath: this.objectPath,
          currentView: this,
          ladTableConfiguration,
          renderWhenVisible
        },
        data: () => {
          return {
            domainObject: this.domainObject
          };
        },
        template: '<lad-table-set ref="ladTableSet" :domain-object="domainObject"></lad-table-set>'
      },
      {
        app: this.openmct.app,
        element
      }
    );
    this._destroy = destroy;
    this.component = vNode.componentInstance;
  }

  getViewContext() {
    if (!this.component) {
      return {};
    }

    return this.component.$refs.ladTableSet.getViewContext();
  }

  destroy() {
    if (this._destroy) {
      this._destroy();
    }
  }
}
